import React from 'react';

export default function InvalidFeedback({error}) {
  if (error) {
    return <small className="invalid-feedback">{error.message}</small>;
  } else {
    return null;
  }
}
